import { render } from "./OrthoToothDetail.vue?vue&type=template&id=761868ee&scoped=true"
import script from "./OrthoToothDetail.vue?vue&type=script&lang=js"
export * from "./OrthoToothDetail.vue?vue&type=script&lang=js"

import "./OrthoToothDetail.vue?vue&type=style&index=0&id=761868ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761868ee"]])

export default __exports__